
















import { Prop, Component, Vue } from "vue-property-decorator";
import AppHeader from "./AppHeader.vue";

@Component({
  components: {
    AppHeader
  }
})
export default class ReceiveServiceInvitation extends Vue {
  @Prop({ required: true }) inviteCode!: string;
  @Prop({ default: () => [] }) errors!: string[];

  async accept() {
    await this.$emit("accept", this.inviteCode);
  }
}
